module.exports = __webpack_public_path__ + "static/st1-1-f9a40013aa6096144e46f00b41c7a0e2.jpg";